<topic-detail></topic-detail>
<responses
  [topic]="topic"
  [showAll]="showAll">
</responses>
